import styled, { css } from 'styled-components'

const footerButtonBase = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, opacity 0.2s ease;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const FormFooter = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
`

export const PrimaryActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;

  > .rankmi-modal-host {
    position: absolute;
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    overflow: visible;
    flex: 0 0 0;
    pointer-events: none;
  }
`

export const BackButton = styled.button`
  ${footerButtonBase};
  gap: 8px;
  flex-shrink: 0;
  background: #f0f0f0;
  color: #4c4c4c;

  svg {
    width: 16px;
    height: 16px;
    font-size: 14px;
  }

  &:hover:not(:disabled) {
    background: #e0e0e0;
    color: #363636;
  }
`

export const PreviewButton = styled.button`
  ${footerButtonBase};
  background: #f0f0f0;
  color: #4c4c4c;

  &:hover:not(:disabled) {
    background: #e0e0e0;
    color: #363636;
  }
`

export const SaveDraftButton = styled.button`
  ${footerButtonBase};
  background: #36b37e;
  color: #fff;

  &:hover:not(:disabled) {
    background: #2d9a6a;
    color: #fff;
  }
`

export const PublishCourseButton = styled.button`
  ${footerButtonBase};
  background: #0085ff;
  color: #fff;

  &:hover:not(:disabled) {
    background: #0070d9;
    color: #fff;
  }
`
